<template>
  <CToaster :autohide="autohide" position="top-right">
    <template v-for="(alert, index) in alerts">
      <CToast
        :key="'toast' + index"
        :show="true"
        :class="'toast-' + alert.color"
        header=" "
        :fade="false"
      >
        {{ alert.message }}
      </CToast>
    </template>
  </CToaster>
</template>

<script>
export default {
  name: "FlashToaster",
  data() {
    return {
      autohide: 3000,
    };
  },
  computed: {
    alerts() {
      return this.$store.state.flashAlert;
    },
  },
};
</script>
<style lang="scss" scoped>
.toast-success {
  color: #18603a;
  background-color: #d5f1de !important;
  border-color: #c4ebd1 !important;
}

.toast-success .toast-header {
  color: #18603a;
  background-color: #d5f1de !important;
  border-color: #c4ebd1 !important;
}
.toast-danger {
  color: #721c24;
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
}
.toast-warning {
  color: #856404;
  background-color: #fff3cd !important;
  border-color: #ffeeba !important;
}
.toast-info {
  color: #0c5460;
  background-color: #d1ecf1 !important;
  border-color: #bee5eb !important;
}
</style>
